module.exports = __webpack_public_path__ + "05_short_gold.f4cfc878.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/aoyama/dad/layer5/05_short_gold.png
// module id = oXE7
// module chunks = 0